import * as z from "zod/v4";

const AeoPromptFilteredSchema_ = z.object({
  id: z.string(),
  prompt: z.string(),
  category: z.string(),
  sources: z.number(),
  createdAt: z.string(),
  deletedAt: z.string().nullable(),
});

export const AeoPromptFilteredSchema: z.ZodType<AeoPromptFilteredSchema> =
  AeoPromptFilteredSchema_;
export interface AeoPromptFilteredSchema
  extends z.infer<typeof AeoPromptFilteredSchema_> {}

export const getAeoPromptsFiltered = {
  name: "getAeoPromptsFiltered" as const,
  input: z.object({
    status: z.enum(["active", "archived"]).default("active"),
    category: z.string().optional(),
    search: z.string().optional(),
  }),
  output: z.array(AeoPromptFilteredSchema),
};
